import React, { useCallback, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { message, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { PaymentService } from '~/services/PaymentService';
import { ERROR_PAGE_ROUTE, HOME_ROUTE } from '~/routing/routes';
import { LoadingContext } from '~/contexts/LoaderContext';
import { GeneralException } from '~/exceptions/generalException';
import { GetPaymentResponse } from '~/entities/responses/getPaymentResponse';
import { CyberSourceService, ValidatePaymentBody } from '~/services/CyberSourceService';
import Loader from '~/components/Loader/Loader';
import { CryptoService } from '~/services/CryptoService';

import './ValidatePayment.scss';

const ValidatePayment: React.FC = () => {
  const location = useLocation();
  const { push: redirect } = useHistory();

  const { startLoading, stopLoading } = useContext(LoadingContext);

  const { t } = useTranslation();

  const getTransactionDetails = useCallback(async (transactionRef: string) => {
    startLoading();
    try {
      const res = await PaymentService.getTransactionDetails(transactionRef);
      const {
        data,
        data: {
          transaction: { status },
        },
      } = res;

      console.log('own status', status);

      if (data !== null && data !== undefined) {
        switch (
          status // transaction.status
        ) {
          case 'ACCEPTED': // successful
            redirect(HOME_ROUTE()); // SUCCESS_PAGE_ROUTE
            break;
          case 'REFUSED': // failed REJECTED
            redirect(HOME_ROUTE());
            break;
          case 'PENDING':
            redirect(HOME_ROUTE());
            break;
          default:
            redirect(ERROR_PAGE_ROUTE());
            break;
        }
      } else {
        redirect(ERROR_PAGE_ROUTE());
      }
      stopLoading();
    } catch (error: any) {
      stopLoading();
      const exception = error.response?.data as GeneralException;
      message.error(exception.description || t('home:global:generalResponse'), 3);
    }
  }, []);

  const validatePayment = useCallback(async () => {
    console.log('INSIDE validate payment');
    const validateDetailsBody = JSON.parse(localStorage.getItem('validateDetails') as string) as ValidatePaymentBody;
    console.log('validateDetailsBody', validateDetailsBody);
    try {
      const res = await CyberSourceService.validatePayment(validateDetailsBody);
      switch (res.data.status) {
        case 'ACCEPTED':
          getTransactionDetails(res.data.transactionRef);
          break;
        case 'REFUSED':
          getTransactionDetails(res.data.transactionRef);
          break;
        case 'REJECTED':
          getTransactionDetails(res.data.transactionRef);
          break;
        default:
          break;
      }
    } catch (error: any) {
      const exception = error.response?.data as GeneralException;
      message.error(exception.description || t('home:global:generalResponse'), 3);
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const transactionRef = String(queryParams.get('transactionRef'));
    // const id = String(queryParams.get('Id'));

    const cryptonit = new CryptoService();
    cryptonit.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
    const decryptData = cryptonit.decryptData(localStorage.getItem('data') as string) as GetPaymentResponse;

    const transactionDetails = decryptData;
    // JSON.parse(localStorage.getItem('data') as string) as GetPaymentResponse;

    if (transactionRef !== transactionDetails.data.transactionRef) {
      return;
    }

    validatePayment();
    // getTransactionDetails(transactionRef);
  }, []);

  return (
    <div className="getPaymentStatus">
      <Row justify="center">
        <Loader />
      </Row>
    </div>
  );
};

export default ValidatePayment;
